import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

const text = ({ palette }: InternalThemeConfig) => ({
    text: {
        padding: "1.3rem 2.4rem 1.1rem 2.4rem",
        fontSize: "1.4rem",
        lineHeight: "1.6rem",
        letterSpacing: "0.015em",

        "&:disabled": {
            background: "none",
        },

        "&.MuiButton-textSizeSmall:not(.CezIconButton)": {
            padding: "0.9rem 1.6rem 0.7rem 1.6rem",
            fontSize: "1.2rem",
            lineHeight: "1.6rem",
            letterSpacing: "0.015em",
        },
        "&.MuiButton-textSizeLarge:not(.CezIconButton)": {
            fontSize: "1.6rem",
            lineHeight: "1.6rem",
            letterSpacing: "0.015em",
            padding: "2.1rem 3.2rem 1.9rem 3.2rem",
        },
    },
    textPrimary: {
        "&:hover": {
            background: undefined,
            backgroundColor: hexToRGBA(palette.primary, 0.12),
        },
        "&:active": {
            backgroundColor: hexToRGBA(palette.primary, 0.12),
        },
        "@media (hover: none)": {
            "&:hover": {
                backgroundColor: "transparent",
            },
            "&:active": {
                backgroundColor: "transparent",
            },
        },
    },
});

export default text;
